import LOGO from "../images/pecanbros.png";

export const Team__PecanBros = {
  name: "Pecan Bros",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#4cf005ff",
  teamJerseyColor: "#0E293D",

  // Stats
  gamesWon: 2,
  gamesLost: 1,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 0,
  goalsScoredAgainst: 32 + 34 + 36,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [
    {
      goalsScored: 31 + 48 + 40,
    },
  ],
};
